// extracted by mini-css-extract-plugin
export default {"wrapper":"Date_wrapper__u7GdV"};